<div class="issue">
    <div class="issue-message">
        <h2 class="mt-2 ml-2" style="color: red;">Keycloack connection issue</h2>
        <div style="margin-top: 70px;">
            <h3 class="mt-2 ml-2">There's an issue with authentication server right now. We're working to restore
                access. Please check back soon.</h3>
        </div>
    </div>
</div>